import { getPlatformMark } from "@mairko/brand";
import { cn } from "@/lib/utils";

type Props = {
	markId: string;
	size?: number;
	className?: string;
	/** Fallback letter when mark missing. */
	fallback?: string;
};

/** Renders a brand catalog mark (same Iconify set as marketing PlatformRail). */
export function PlatformMark({
	markId,
	size = 16,
	className,
	fallback,
}: Props) {
	const mark = getPlatformMark(markId, size);
	if (!mark) {
		return (
			<span
				className={cn(
					"grid place-items-center rounded text-[10px] font-semibold text-mx-tertiary",
					className,
				)}
				style={{ width: size, height: size }}
				aria-hidden
			>
				{(fallback ?? markId).slice(0, 1).toUpperCase()}
			</span>
		);
	}
	return (
		<span
			className={cn("inline-flex shrink-0 [&_svg]:block", className)}
			style={{ width: size, height: size }}
			aria-hidden
			dangerouslySetInnerHTML={{ __html: mark.svg }}
		/>
	);
}
